import { apiFetch } from "../fetchApi";

export const fetchCardsCount = async (BeURL, showAlert, companyId, setCounts) => {
    try {
        // 2️⃣ Send companyId as param for get manager Ids creation
        const res = await apiFetch(`${BeURL}/admin/metrics/${companyId}`, {
            method: "GET",
        });

        const data = await res.json();
        if (!data.success) {
            showAlert(data.message);
            return;
        }

        setCounts(data.metrics)


    } catch (err) {
        console.error("Error in Fetch Manager:", err);
        alert('Trouble connecting to the server! Please try again later.');
    }

}